export class ObjectHelper {
    static removeEmpty(obj: any) {
        return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
    }
}